import React from 'react';
import { FormControl, TextField, FormHelperText, Box } from '@mui/material';

export default function StartCommandField({ value, onChange, edit, error }) {
  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          label='Start Command'
          id='start_command'
          name='start_command'
          value={value || ''}
          onChange={handleChange}
          disabled={edit}
          error={Boolean(error)}
          variant='outlined'
          fullWidth
        />
        {error ? (
          <FormHelperText>Start command is required</FormHelperText>
        ) : (
          <FormHelperText>Enter the server start command</FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

